module.exports = [
  {
    product_code: '0000',
    icon: '/illustrations/products/general-01.png',
  },
  {
    product_code: '2877',
    icon: '/illustrations/products/Secure Shield.jpg',
  },
  {
    product_code: '2880',
    icon: '/illustrations/products/Health Plus.jpg',
  },
  {
    product_code: '2883',
    icon: '/illustrations/products/Health Premier.jpg',
  },
  {
    product_code: '2885',
    icon: '/illustrations/products/Aarogya Sanjivani.jpg',
  },
  {
    product_code: '3191',
    icon: '/illustrations/products/TW_Secure.jpg',
  },
  {
    product_code: '3192',
    icon: '/illustrations/products/TW_LiabilityOnly.jpg',
  },
  {
    product_code: '3137',
    icon: '/illustrations/products/GCV.jpg',
  },
  {
    product_code: '3183',
    icon: '/illustrations/products/PCV.jpg',
  },
  {
    product_code: '3153',
    icon: '/illustrations/products/Accident-Cover.jpg',
  },
  {
    product_code: '3152',
    icon: '/illustrations/products/two-wheeler-03.png',
  },
  {
    product_code: '3151',
    icon: '/illustrations/products/two-wheeler-04.png',
  },
  {
    product_code: '3121',
    icon: '/illustrations/products/car-01.png',
  },
  {
    product_code: '3128',
    icon: '/illustrations/products/MISCD.jpg',
  },
  {
    product_code: '4201',
    icon: '/illustrations/products/ipa-01.png',
  },
  {
    product_code: '1132',
    icon: '/illustrations/products/fire-01.png',
  },
  {
    product_code: '1133',
    icon: '/illustrations/products/fire-02.png',
  },
  {
    product_code: '1131',
    icon: '/illustrations/products/fire-03.png',
  },
  {
    product_code: '2117',
    icon: '/illustrations/products/marine-01.png',
  },
  {
    product_code: '4501',
    icon: '/illustrations/products/travel-01.png',
  },
  {
    product_code: '2904',
    icon: '/illustrations/products/misc-01.png',
  },
  {
    product_code: '2901',
    icon: '/illustrations/products/misc-02.png',
  },
];
